import React, { ReactChild } from 'react';
import PropTypes from 'prop-types';
import { StyledPlayText } from './PlayText.styles';

export type PlayTextProps = {
    fontColor?: string;
    size?: string;
    weight?: string | number;
    underline?: boolean;
    children?: ReactChild;
    className?: string;
    error?: boolean;
    dataRt?: string;
    as?: string;
};

export const SIZE = {
    MINI: 'MINI',
    SMALL: 'SMALL',
    DEFAULT: 'DEFAULT',
    LARGE: 'LARGE',
    XLARGE: 'XLARGE',
    XXLARGE: 'XXLARGE',
};
const PlayText = ({
    fontColor,
    size,
    weight,
    underline,
    children,
    className,
    error,
    dataRt,
    as,
}: PlayTextProps) => (
    <StyledPlayText
        weight={weight}
        fontColor={fontColor}
        size={size}
        underline={underline}
        className={className}
        error={error}
        data-rt={dataRt}
        as={as}
    >
        {children}
    </StyledPlayText>
);
PlayText.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOf(['MINI', 'SMALL', 'DEFAULT', 'LARGE', 'XLARGE']),
    underline: PropTypes.bool,
    children: PropTypes.node,
};
export default PlayText;
